import { useEffect, useState } from "react";
import DashContent from "../../components/Dash/DashContent";
import { getDashboardSummary } from "../../endpoints/Dashboard/functions";
const DashPage = (props) => {
  const [dash, setDash] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await getDashboardSummary(props.token);
        setDash(response);
        setLoading(false);
      } catch (error) {
        console.warn("Error at fetchData for DashPage");
      }
    };
    fetchData();
  }, [props.token]);

  return (
    <div className="page-box">
      <DashContent dash={dash} loading={loading} />
    </div>
  );
};

export default DashPage;
